import { oauthButtonHandler } from "./oauth-utils";

/* Load the Google API */
function loadGoogleAuth() {
  waitForNavBarWithAttempts = (attempts) => {
    return(
      () => {
        if (document.querySelector('.logout') === null && attempts < 10) {
          setTimeout(waitForNavBarWithAttempts(attempts + 1), 1000)
        } else {

          const logoutLinks = document.querySelectorAll('.logout');

          gapi.load('auth2', () => gapi.auth2.init());

          // If a user ever logs out, log them out of any corresponding Google
          // Account session too
          [...logoutLinks].forEach((link) => {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              const gAuth = gapi.auth2.getAuthInstance();
              if (gAuth) {
                gAuth.signOut();
              }
              window.location.href = e.target.href;
            });
          });
        }
      }
    )
  }

  setTimeout(waitForNavBarWithAttempts(0), 500);
}

const googleSignOut = () => {
  gapi.auth2.getAuthInstance().signOut();
};

/* Event listener for unlocking an article with Google */
async function unlockContentWithGoogle(googleUser) {
  const googleBtn = document.querySelector('div[data-onsuccess="unlockContentWithGoogle"]'),
    optInCheckbox = googleBtn
      .closest('.read-this-article-immersive, .read-this-article, #immersive-article-modal')
      .querySelector('.opt-in');
  await oauthButtonHandler({
    idToken: googleUser.getAuthResponse().id_token,
    verificationUri: googleBtn.attributes['data-verification-uri'].value, // A rails route helper is attached to the button's data-redirect-uri attribute
    verificationExtras: {
      article_id: currentPage.articleId,
      briefing_guid: currentPage.briefingGuid, // a user can unlock an article or a briefing
      declined_opt_in: optInCheckbox ? optInCheckbox.checked == false : false,
      opt_in_required: !!optInCheckbox,
      provider: 'google',
    },
  });
}

/* Event listener for logging in with Google */
async function logInWithGoogle(googleUser) {
  const googleBtn = document.querySelector('div[data-onsuccess="window.logInWithGoogle"]');
  await oauthButtonHandler({
    idToken: googleUser.getAuthResponse().id_token,
    verificationUri: googleBtn.attributes['data-redirect-uri'].value,
    verificationExtras: {
      returning_url: googleBtn.attributes['data-returning-uri'].value,
      provider: 'google',
    },
  });
}

/* Event listener for Sign Up with Google */
async function createLeadWithGoogle(googleUser) {
  const googleBtn = document.querySelector('div[data-onsuccess="createLeadWithGoogle"]'),
    optInCheckbox = googleBtn
      .closest(
        '.locked, .read-this-article-immersive, .read-this-article, #immersive-article-modal, .ti-static, .newsletter-landing, #newsletters'
      )
      .querySelector('.opt-in'),
    leadType = googleBtn.dataset.leadType,
    returningUri = googleBtn.dataset.returningUri;
  await oauthButtonHandler({
    idToken: googleUser.getAuthResponse().id_token,
    verificationUri: googleBtn.attributes['data-verification-uri'].value,
    verificationExtras: {
      declined_opt_in: optInCheckbox ? optInCheckbox.checked == false : false,
      lead_type: leadType,
      opt_in_required: !!optInCheckbox,
      returning_uri: returningUri,
      provider: 'google',
    },
  });
}

export { logInWithGoogle, createLeadWithGoogle, unlockContentWithGoogle, googleSignOut }
